const DEFAULT_PASSWORD_POLICY_MESSAGE = '비밀번호 정책을 확인해 주세요.'

export const PASSWORD_REQUIREMENTS_MESSAGE = '10~64자의 영문, 숫자, 특수기호 중 2종 이상을 조합해 주세요. 공백은 사용할 수 없습니다.'

const ENGLISH_LETTER_PATTERN = /[A-Za-z]/
const NUMBER_PATTERN = /[0-9]/
const ASCII_SPECIAL_CHARACTER_PATTERN = /[\u0021-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u007E]/
const ALLOWED_PASSWORD_CHARACTER_PATTERN = /^[A-Za-z0-9\u0021-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u007E]+$/

const AUTH_ERROR_MESSAGES = {
  '1001121': '로그인 시도 횟수가 너무 많습니다. 잠시 후 다시 시도해주세요.',
  '1001185': '비밀번호 인증이 비활성화되었습니다. 비밀번호를 초기화해 주세요.',
}

export function getTokenPayload(data = {}) {
  return data && data.token ? data.token : data || {}
}

export function getAccessTokenFromResponse(data = {}) {
  const token = getTokenPayload(data)
  return token.access_token || token.accessToken || ''
}

export function getRefreshTokenFromResponse(data = {}) {
  const token = getTokenPayload(data)
  return token.refresh_token || token.refreshToken || ''
}

export function shouldStoreRefreshToken(authRefreshMode = 'legacy') {
  return authRefreshMode !== 'cookie'
}

export function getAuthErrorData(errorOrData = {}) {
  return errorOrData && errorOrData.response && errorOrData.response.data
    ? errorOrData.response.data
    : errorOrData || {}
}

export function normalizeAuthErrorCode(errorOrData = {}) {
  const data = getAuthErrorData(errorOrData)
  return data.err_code === undefined || data.err_code === null ? '' : String(data.err_code)
}

export function getPasswordPolicyMessage(errorOrData = {}) {
  const data = getAuthErrorData(errorOrData)
  if (data.err_msg) return data.err_msg

  const firstPasswordError = Array.isArray(data.password_errors) ? data.password_errors[0] : null
  return (firstPasswordError && (firstPasswordError.message || firstPasswordError)) || DEFAULT_PASSWORD_POLICY_MESSAGE
}

export function getPasswordPolicyError(password = '') {
  const passwordLength = Array.from(password).length
  const characterTypeCount = [
    ENGLISH_LETTER_PATTERN,
    NUMBER_PATTERN,
    ASCII_SPECIAL_CHARACTER_PATTERN,
  ].filter(pattern => pattern.test(password)).length

  if (!ALLOWED_PASSWORD_CHARACTER_PATTERN.test(password) || passwordLength < 10 || passwordLength > 64 || characterTypeCount < 2) {
    return PASSWORD_REQUIREMENTS_MESSAGE
  }
  return ''
}

export function getAuthErrorMessage(errorOrData = {}) {
  const code = normalizeAuthErrorCode(errorOrData)
  if (code === '1001184') return getPasswordPolicyMessage(errorOrData)
  return AUTH_ERROR_MESSAGES[code] || ''
}
